import {
  CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST,
  CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressIsLastInPersonSignerState = boolean;

const initialState: ContractProgressIsLastInPersonSignerState = false;

export default function reducer(
  state: ContractProgressIsLastInPersonSignerState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_SUCCESS:
      return action.payload.isLastInPersonSigner;
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
